// File: Step2PricingCategory.tsx
import React from 'react';
import { Category } from '../../../../types';

interface StepProps {
  formData: {
    basePrice: number | string;
    category: string | number;
  };
  onInputChange: (field: string, value: any) => void;
  categories: Category[];
}

const Step2PricingCategory: React.FC<StepProps> = ({ formData, onInputChange, categories }) => {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-gray-800">Pricing & Category</h3>

      {/* Base Price */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          What is the base price? *
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-500 text-lg">$</span>
          </div>
          <input
            type="number"
            required
            min="0"
            step="0.01"
            value={formData.basePrice}
            onChange={(e) => onInputChange('basePrice', e.target.value)}
            className="block w-full pl-10 pr-4 py-3 text-lg border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="0.00"
          />
        </div>
        <p className="mt-1 text-sm text-gray-500">This is the standard price for the product</p>
      </div>

      {/* Category */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Select a category
        </label>
        <select
          value={formData.category}
          onChange={(e) => onInputChange('category', e.target.value)}
          className="block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Choose a category...</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.name}
            </option>
          ))}
        </select>
        <p className="mt-1 text-sm text-gray-500">Select the most relevant category for your product</p>
      </div>
    </div>
  );
};

export default Step2PricingCategory;
